// Off-Canvas-Menü (anonymer Zustand)
// Wird von script.js (b2b) und script_catalog.js (catalog) importiert.
export function initOffcanvasMenu() {
    const $menu = $('#offcanvas_menu');
    if (!$menu.length) return;

    // Sub-Kategorien aufklappbar machen (Chevron-Button pro Eltern-LI)
    const chevronSvg = '<svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

    $menu.find('.offcanvas_col_nav li').each(function (idx) {
        const $li = $(this);
        const $subUl = $li.children('ul').first();
        if (!$subUl.length) return;

        const subId = 'offcanvas_sub_' + idx;
        $subUl.attr('id', subId);

        const $btn = $('<button type="button" class="offcanvas_col_toggle" aria-expanded="false">' +
            '<span class="sr-only">Unterkategorien anzeigen</span>' +
            chevronSvg +
            '</button>');
        $btn.attr('aria-controls', subId);

        $li.addClass('has-children');
        $subUl.before($btn);
        $btn.on('click', function (e) {
            e.preventDefault();
            const expanded = $btn.attr('aria-expanded') === 'true';
            if (!expanded) {
                // Accordion: nur eine Kategorie pro Ebene aufgeklappt
                $li.siblings('.is-open').each(function () {
                    const $sibling = $(this);
                    $sibling.removeClass('is-open');
                    $sibling.children('.offcanvas_col_toggle').attr('aria-expanded', 'false');
                });
            }
            $btn.attr('aria-expanded', expanded ? 'false' : 'true');
            $li.toggleClass('is-open', !expanded);
        });
    });

    const $toggle = $('#toggle_offcanvas');
    const $body = $('body');
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function focusableElements() {
        return $menu.find(FOCUSABLE).filter(':visible').toArray();
    }

    function openMenu() {
        $menu.addClass('is-open').attr('aria-hidden', 'false');
        $toggle.attr('aria-expanded', 'true');
        $body.addClass('offcanvas-open');
        setTimeout(function () {
            $menu.find('#offcanvas_search_input').trigger('focus');
        }, 250);
    }

    function closeMenu() {
        $menu.removeClass('is-open').attr('aria-hidden', 'true');
        $toggle.attr('aria-expanded', 'false');
        $body.removeClass('offcanvas-open');
        $toggle.trigger('focus');
    }

    $toggle.on('click', openMenu);
    $menu.find('.offcanvas_close').on('click', closeMenu);

    $(document).on('keydown', function (e) {
        if (!$menu.hasClass('is-open')) return;

        if (e.key === 'Escape') {
            closeMenu();
            return;
        }

        // Focus-Trap: Tab/Shift+Tab wrappt innerhalb des Menüs
        if (e.key === 'Tab') {
            const focusables = focusableElements();
            if (focusables.length === 0) return;
            const first = focusables[0];
            const last = focusables[focusables.length - 1];
            const active = document.activeElement;
            if (e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });
}
